// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__ib5bY","content":"LayoutSettings_content__1ok3T"};